import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useClubHasPackages_club$key } from "./__generated__/useClubHasPackages_club.graphql";

export const useClubHasPackages = (
  clubRef?: useClubHasPackages_club$key | null
) => {
  const club = useFragment(useClubHasPackagesFragmentString, clubRef);

  return club?.supportsPublic && (club?.packages?.count ?? 0) > 0;
};

const useClubHasPackagesFragmentString = graphql`
  fragment useClubHasPackages_club on Club {
    supportsPublic
    packages(packageType: STANDARD, saleAvailability: PUBLIC) {
      count
    }
  }
`;
